// @ts-nocheck
import "./App.css";
import { useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import { styled, useMediaQuery, useTheme } from "@mui/material";
import { AuthProvider } from "./services/AuthContext";
import { SignalRProvider } from "./services/context/SignalRContext";
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from "../ErrorBoundary";
import { useDispatch, useSelector } from "react-redux";
import { closeMenuBar, openMenuBar } from "./redux/slice/menuSlice";
import CommonFooter from "./components/commonComponents/CommonFooter";
import { setLastVisitedPage } from './redux/slice/navigationSlice';
import { clearAllMyBidUpdates, clearMyBidUpdates } from "./redux/slice/mybidSlice";
import { useRef } from 'react';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const drawerWidth = 280;

export default function App() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const open = useSelector((state) => state.menu.isOpen);
  const location = useLocation();
  const userData = useSelector((store: RootState) => store.user.loginUserDetails)

  useEffect(() => {
    if (!isMobile) {
      dispatch(openMenuBar())
    } else {
      dispatch(closeMenuBar())
    }
  }, [isMobile, dispatch])

  useEffect(() => {
    dispatch(setLastVisitedPage(location.pathname));
  }, [location.pathname, dispatch]);

  const Main = useMemo(() => styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme }) => ({
      flexGrow: 1,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      variants: [
        {
          props: ({ open }) => open,
          style: {
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: `${drawerWidth * .95}px`,
          },
        },
      ],
    })
  ), []);

  const openCondition = isMobile ? false : open;
  const isImpersonate = sessionStorage.getItem("isImpersonate")
  const prevIsImpersonate = usePrevious(isImpersonate);



  return (
    <SignalRProvider>
      {isImpersonate && <header className="bg-[#FF5c39] fixed z-[99999] w-[100%] text-white h-[33px] text-center items-center flex justify-center capitalize"> IMPERSONATING {userData?.ProfileName?.length > 2 ? userData?.ProfileName : userData?.BusinessAccounts?.[0]?.ProfileName || userData?.FirstName + " " + userData?.LastName} </header>}
      <Main
        className={`${isImpersonate ? `pt-[120px]` : `pt-[80px]`} sm:ml-[50px] px-4 ${open ? "sm:pl-3" : "sm:pl-6"} pr-3 min-h-[108vh] relative `}
        open={openCondition}
      >
        <Sidebar open={open} setOpen={(newOpen) => newOpen ? dispatch(openMenuBar()) : dispatch(closeMenuBar())} isLogin />
        <div className="flex flex-col xs:min-h-[75vh] "> {/* Adjust content height */}
          <Outlet context={isMobile} className="flex-1" />
        </div>
        <CommonFooter open={open} />
      </Main>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover
        theme="light"
        {...(isImpersonate ? { style: { top: 45 } } : {})}
      />

    </SignalRProvider>
  );
}
